import { useEffect, useState } from 'react'
import { useStyletron } from 'baseui'

function useGetAvatarColor(username: string): string {
    const [css, theme] = useStyletron()
    const [color, setColor] = useState<string>(theme.colors.primary)

    useEffect(() => {
        if (username !== '') {
            const colors = [
                theme.colors.accent,
                theme.colors.accent100,
                theme.colors.accent200,
                theme.colors.accent300,
                theme.colors.accent400,
                theme.colors.accent500,
                theme.colors.accent600,
                theme.colors.accent700,
                theme.colors.positive,
                theme.colors.positive100,
                theme.colors.positive200,
                theme.colors.positive300,
                theme.colors.positive400,
                theme.colors.positive500,
                theme.colors.positive600,
                theme.colors.positive700,
                theme.colors.warning,
                theme.colors.warning100,
                theme.colors.warning200,
                theme.colors.warning300,
                theme.colors.warning400,
                theme.colors.warning500,
                theme.colors.warning600,
                theme.colors.warning700,
                theme.colors.negative,
                theme.colors.negative100,
                theme.colors.negative200,
                theme.colors.negative300,
                theme.colors.negative400,
                theme.colors.negative500,
                theme.colors.negative600,
                theme.colors.negative700,
            ]
            const c = colors[getHashOfString(username) % colors.length];
            setColor(c);
        }
    }, [username])

    return color
}

export default useGetAvatarColor


export const getHashOfString = (str: string) : number => {
    if ( !str )
        return 0;
    const charArray = Array.from(str);
    return charArray.reduce((total, _char, index) => {
      return total += str.charCodeAt(index);
    }, 0);
  }
